import { UserSummaryProductModel } from "./../../models/user-summary/user-summary-product.model";
import { UserSummaryModel } from "./../../models/user-summary/user-summary.model";
import { KEY_CONFIG } from "lib/ng2-sapmp/src/config/key-config";
import { Location } from "@angular/common";
import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder,
} from "@angular/forms";
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  HostListener,
  ElementRef,
  AfterViewChecked,
  AfterViewInit,
} from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { PageLoaderService } from "lib/ng2-sapmp/src/ui-components";
import { UtilityService, ValidationService } from "lib/ng2-sapmp/src/providers";
import { BreadCrumbService } from "lib/ng2-sapmp/src/ui-components/breadcrumb";
import {
  ManageDashboardService,
  ReportRequestModel,
  MDMDetails,
} from "./shared";
import { DonutRangeModel } from "lib/ng2-sapmp/src/ui-components/charts";
import {
  UserWizardService,
  AuthenticationService,
  AdobeAnalyticsService,
} from "lib/ng2-sapmp/src/providers";
import { UserWizardModel, UserProfileModel } from "lib/ng2-sapmp/src/models";
import { FetchCriteriaModel } from "lib/ng2-sapmp/src/ui-components/custom-grid";
import { Router, ActivatedRoute } from "@angular/router";
import { StepIndicatorService } from "lib/ng2-sapmp/src/ui-components/step-indicator";
import { FormBuilderService } from "lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service";
import {
  UserSummaryDataService,
  RequestUserSummaryModel,
} from "./../user-summary/shared";
import { UserSummaryProdInfoModel, UserManageModel } from "./../../models/";
import { DonutChartModel } from "lib/ng2-sapmp/src/ui-components/charts/donut-chart";
import {
  CHART_CONFIG,
  ADDP_PERMISSION_MAPPING,
  ERRCODES,
  ADDP_PERMISSION_MAPPING_FNABC,
  EFOTA_CHART_CONFIG,
} from "config";
import { InitialService } from "./../initial-signup/initial-signup.service";
import { ConfirmModalPopupModel } from "lib/ng2-sapmp/src/ui-components";
import { HomeService } from "lib/ng2-sapmp/src/pages/home/shared/providers/home.service";

export const COLOR = "#0568ae";
export const OFFER_COUNT = "3";

declare var initAriaHidden: any;
declare var removeAriaHidden: any;
declare var ENV_PORTAL: any;

@Component({
  selector: "app-manage-dashboard",
  providers: [
    ManageDashboardService,
    FormBuilderService,
    ValidationService,
    StepIndicatorService,
    UserSummaryDataService,
    InitialService,
    HomeService,
  ],
  templateUrl: "./manage-dashboard.component.html",
  styleUrls: ["./manage-dashboard.component.scss"],
})
export class ManageDashboardComponent
  implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  user_manage_info: UserManageModel;
  formInputData: UserSummaryProdInfoModel;
  requestUserSummaryModel: RequestUserSummaryModel;
  id: string;
  confirmModalPopup: ConfirmModalPopupModel;
  user: UserProfileModel;
  multipleUserFlag: boolean;
  reqObj: any;
  searchFlag: boolean;
  errorMsg = "";
  errorMsgCheck: boolean;
  searchResponse: any;
  searchUser: FormGroup;
  focusabbleElements: any;
  usersPopup: boolean;
  productResponse: any;
  userResponse: any;
  rightLabel: string;
  leftLabel: string;
  radius = "90";
  fanList: any;
  stroke_width = "15";
  values: Array<DonutRangeModel>;
  userWizardModel: UserWizardModel;
  reportRequestModel: ReportRequestModel;
  mdmDetails: MDMDetails;
  fetchCriteriaModel: FetchCriteriaModel;
  reviewComponentSuccessMessage = null;
  reviewComponentSuccessMessageFlag = false;
  readyToSetup = false;
  manage_manageusers: string;
  @ViewChild("search") searchElement;
  @ViewChild("fullName") fullNameElement;
  @ViewChild("searchName") searchNameElement;
  donutLabel: string;
  donutLabelText: string;
  donutUserValue: string;
  productResponseValid: boolean;
  userResponseValid: boolean;
  showUsersChartReport: boolean;
  invalidCompanyId: boolean;
  loadComplete: boolean;
  companyNotFound = false;
  modalClass: string;
  showReportPopup = false;
  cancelParticipationRoute: string;
  overviewModalPopup: ConfirmModalPopupModel;

  manageInventoryPage: any;
  chartLabel: any;
  chartData: any;
  legendData: any;
  chartRadius = 90;
  strokeWidth = 20;
  startIndex = 0;
  recordsPerPage = 9;
  fanDevicesReq: any;
  isSearch: boolean;
  fanSearch: FormControl;
  fieldPermissions: any;
  smsSent: boolean;
  companyId = 0;
  fanStatus: any;
  dashboardData: any;
  showData: boolean;
  showEfota: boolean = false;
  appleInstalled: any;
  apiError = false;
  hasAddpPermission: boolean;
  hasAmPermission: boolean;
  permissionLevelMessage: string;
  hasAddpFullPermission = false;
  deviceStatus: string;
  emmProductCode: any;
  oemStatus = false;
  userDetail: any;
  manageDeploymentMixedFans: boolean;
  eligibleFanCount: any = 0;
  stringAccount = "account(s)";
  manageProduct: any;
  accountDetails: any;
  FanLegendCount = 0;
  loaderOtherScenario: boolean = true;
  envPortal: string;
  eventEmit: any;
  activeSigedupFans : any;

  enrollMultiplePrograms = 0;
  enrollSingleProgram = 0;
  notEnrolledProgram = 0;
  enrollPendingProgram = 0;
  enrollMultiPendingPrograms = 0;
  sendActiveCount = 0;

  public showNotEligible = false;
  public showUnknown = false;
  public errMsgDisplay: any;
  public hrscompleted: boolean;

  formErrors = {
    fullName: "",
  };

  validationMessages = {
    fullName: {
      isNumber: "Enter a name to search for.",
      length: "Enter atleast 3 characters to search",
      isSpace: "Enter valid characters to search",
    },
  };
  efotaFansSummary: any;
  isEfotaEnrolledFanList: boolean;
  noOfReports: any = 0;
  // efotaEnrolledFans = new Array();
  fansActiveCount: number = 0;
  fansNotSignedUpCount: number = 0;
  isAddAccounts: boolean = false;
  isFullPermissionUser: boolean = false;
  isEfotaNotEnrolledFanList: boolean = false;
  hasNotSignedUpFans: boolean = false;
  isEfotaAccountsTileLarge: boolean = false;
  readyToSetupCount: number;
  processingFansCount: any;
  processingFansFlag: boolean = false;
  changeRequests: any;
  formattedDate: string;
  ModifiedDate: any;
  fanDetails: any;
  checkhr: boolean = false;
  activeFanId: any;
  InprogressFanid: any;
  disableRemoveLink: boolean = false;
  emmProductCodeForFan: any;
  initialSingup: any;
  isSingleABMFE: boolean = false;
  signupStatus: any;
  processingFanList_: any = [];
  showDeviceInventoryIfNotSignedUp: boolean = false;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.tilesHeight();
  }

  constructor(
    private route: ActivatedRoute,
    private userSummaryDataService: UserSummaryDataService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private breadCrumbService: BreadCrumbService,
    private manageDashboardService: ManageDashboardService,
    private utilityService: UtilityService,
    private pageLoaderService: PageLoaderService,
    private userWizardService: UserWizardService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private stepIndicatorService: StepIndicatorService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private InitialService: InitialService,
    private location: Location,
    private homeService: HomeService,
    private el: ElementRef
  ) {
    this.leftLabel = "licenses assigned";
    this.rightLabel = "";
    this.values = new Array<DonutRangeModel>();
    this.usersPopup = false;
    this.reportRequestModel = new ReportRequestModel();
    this.mdmDetails = new MDMDetails();
    this.reportRequestModel.licenseProvisionStatus = new Array<string>();
    this.fetchCriteriaModel = new FetchCriteriaModel();
    this.errorMsgCheck = false;
    this.manage_manageusers = "dashboard.manageUser";
    this.searchFlag = false;
    this.user = new UserProfileModel();
    this.productResponseValid = true;
    this.userResponseValid = false;
    this.invalidCompanyId = true;
    this.loadComplete = false;
    this.userWizardService.removeAssignOrUnassignWizard();
    this.modalClass = "modal-lg";
    var elements = <HTMLElement>document.querySelector("#userProfileInfo");
    elements.style.display = "inline-block";
    elements.setAttribute("tabindex", "1");

    var elements = <HTMLElement>document.querySelector("#hamNav");
    elements.style.display = "inline-block";
    elements.setAttribute("tabindex", "-1");
    const userObj = authenticationService.getUser();
    if (userObj) {
      let userName;
      if (
        (userObj.firstName.length == 0 || userObj.firstName == "NOT_FOUND") &&
        (userObj.lastName.length == 0 || userObj.lastName == "NOT_FOUND")
      ) {
        userName = "Unknown";
      } else if (
        userObj.firstName.length > 0 &&
        userObj.firstName != "NOT_FOUND" &&
        (userObj.lastName.length == 0 || userObj.lastName == "NOT_FOUND")
      ) {
        userName = userObj.firstName;
      } else if (
        (userObj.firstName.length == 0 || userObj.firstName == "NOT_FOUND") &&
        userObj.lastName.length > 0 &&
        userObj.lastName != "NOT_FOUND"
      ) {
        userName = userObj.lastName;
      } else {
        userName = userObj.firstName + " " + userObj.lastName;
      }
      document.getElementsByClassName("first-name")[0].innerHTML = userName;
    }
    let perm = ["PARTIAL", "FULL", "READ_ONLY"];
    const fullPerm = "FULL";
    const userPerm = this.authenticationService.getUser().addpAuthority;
    this.hasAddpPermission = perm.indexOf(userPerm) !== -1;
    this.hasAddpFullPermission = fullPerm.includes(userPerm);
    perm = ["buy_and_manage", "buy_only", "manage_only"];
    const userPermAm = this.authenticationService.getUser().permission;
    this.hasAmPermission = perm.indexOf(userPermAm) !== -1;
    this.envPortal = ENV_PORTAL;
    sessionStorage.removeItem("dashboarddep");
    sessionStorage.removeItem("dashboardefota");
    this.location.replaceState("dashboard/dep");
  }

  ngOnInit() {
    // this.manageDashboardService.getFanDetails().subscribe((respobj) => {
    //   sessionStorage.setItem(
    //     "fanInfoList",
    //     JSON.stringify(respobj.fanInfoList)
    //   );
    //   if(respobj?.fanInfoList && respobj?.fanInfoList.length > 0){
    //     if(respobj.initialSignupStatus === "Not Signed Up"){
    //       let enrollStatus_ = respobj?.fanInfoList.map((elm) => elm.accountStatus);
    //         let fanListData = new Set(enrollStatus_);
    //         if(fanListData.has("SIGNUP_INPROGRESS") && fanListData.has("ACTIVE")){
    //           this.showDeviceInventoryIfNotSignedUp = true;
    //         }else{
    //           this.showDeviceInventoryIfNotSignedUp = false;
    //         }
    //     }
    //   }
      
    //   this.checkErrorMsg();
    // });

    document.title =
      this.utilityService.getPageTitleConfig()[
      this.router.routerState.snapshot.url
      ];
    this.authenticationService.setLoginSuccessUrl(
      this.router.routerState.snapshot.url
    );
    sessionStorage.setItem("callingPageName", "dashboard");
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = "/businessconsole/login";
    }
    sessionStorage.setItem("cancelCallingBackUrl", "/dashboard");
    this.pageLoaderService.setPageLoaderStatus(false);
    this.user = this.authenticationService.getUser();
    this.noOfReports = 0;
    this.noOfReports = sessionStorage.getItem("efotaAlertsCount");
    this.breadCrumbService.setStaticBreadCrumbs("/home");
    this.breadCrumbService.setCurrentBreadCrumb({
      label: "Dashboard", // AT&T Business Console
      routerLink: "/dashboard",
    });
    //let productUrl = (this.utilityService.getEnvConfig().getStatsTops).replace('{companyid}', this.user.companyId); // move this to service
    //let productstatsurl = productUrl.replace('{offercount}', OFFER_COUNT);
    // this.manageDashboardService.dashboardProducts(productstatsurl)
    //   .subscribe(respObj => {
    //     this.reviewSuccess();
    //     this.productResponse = respObj;
    //     if (this.productResponse.length < 1) {
    //       this.productResponseValid = false;
    //     }
    //     const donutUrl = (this.utilityService.getEnvConfig().getStatsUsers).replace('{companyid}', this.user.companyId);
    //     this.manageDashboardService.dashboardDonut(donutUrl)
    //       .subscribe(respObject => {
    //         this.userResponse = respObject;
    //         if (this.userResponse) {
    //const donutUrl = (this.utilityService.getEnvConfig().getStatsUsers).replace('{companyid}', this.user.companyId);
    //const contentUrl = this.utilityService.getEnvConfig().contentUrl.dashboard.dashboardData;
    //let contentResponse: any;
    // ------------------------------------ ForkJoin Start--------------------------------------------------//

    /*this.manageDashboardService.dashboardData(productstatsurl, donutUrl)
      .subscribe(respObj => {
        this.reviewSuccess();
        this.productResponse = respObj[0];
        if (this.productResponse.length < 1) {
          this.productResponseValid = false;
        }
        // donut code starts
        this.userResponse = respObj[1];
        // this.dashboardData = respObj[2];
        if (this.userResponse.length !== 0) {
          const value = (this.userResponse.totalEmployeesWithLicense / this.userResponse.totalEmployees) * 100;
          const donutRange = new DonutRangeModel();
          donutRange.range = value;
          donutRange.color = COLOR;
          this.donutLabel = 'of ' + this.userResponse.totalEmployees + ' users have';
          this.donutLabelText = 'licenses';
          this.donutUserValue = this.userResponse.totalEmployeesWithLicense;
          this.values.push(donutRange);
          this.userResponseValid = true;
          this.showUsersChartReport = true;
          if (this.userResponse.totalEmployees === 0) {
            this.showUsersChartReport = false;
          }
        }
        if (this.hasAddpPermission === false) {
          this.pageLoaderService.setPageLoaderStatus(true);
        }
        // }, error => {
        // this.pageLoaderService.setPageLoaderStatus(true);
        //   this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        //   this.handleError(error);
        // });
        this.invalidCompanyId = false;
        // this.pageLoaderService.setPageLoaderStatus(true);
      }, error => {
        // this.pageLoaderService.setPageLoaderStatus(true);
        this.productResponseValid = false;
        if (error.status === 400) {
          if (error.error[0].errorDescription.indexOf('COMPANY_NOT_FOUND') !== -1) {
            // this.errorMsg = 'No company found. Please place an order to manage products.';
            this.companyNotFound = true;
            this.invalidCompanyId = true;
          } else {
            this.invalidCompanyId = false;
            this.errorMsg = 'We couldn\'t complete your request. Please try again later.';
          }
        }
        this.pageLoaderService.setPageLoaderStatus(true);
        this.utilityService.loadFocusOnTop();
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error, 'FETCH_PAGE');
      });*/
    this.buildForm();
    this.manageDashboardService.createPageLoadProperties(
      this.router.routerState.snapshot.url,
      "Dashboard"
    );

    //this.manageDashboardService.getDashboardContent(this.utilityService.getEnvConfig().contentUrl.dashboard.dashboardData).
    //subscribe(respobj => {
    //this.dashboardData = respobj;
    let child = this.route.snapshot.url[0].path;
    this.showEfota = child === "efota";
    this.dashboardData = this.route.snapshot.data.pageData["dashboard" + child];
    this.dashboardData.useMock = this.utilityService.getEnvConfig().useMock;
    //  this.dashboardData.useMock  = true;
    this.initPage();
    this.accountDetails = JSON.parse(sessionStorage.getItem("mdmDetails"));
    this.manageProduct = sessionStorage.getItem("manage-product");
    this.isFullPermissionUser = this.hasFullPermission();
    this.tilesHeight();
  }

  checkErrorMsg() {
    let currentDate = new Date();
    let str: string = sessionStorage?.fanInfoList;
    let arr = str && str != "undefined" ? JSON.parse(str) : [];
    let fanlistInProgress = arr.filter(
      (data) => data.accountStatus === "ACTIVE"
    );
    this.fanDetails = fanlistInProgress.map((data) => {
      var parts = data.modifiedDate
        ? data.modifiedDate.split(/[- .:]+/)
        : !data.modifiedDate && data.createdDate
          ? data.createdDate.split(/[- .:]+/)
          : null;
      var day = parseInt(parts[0]);
      var month = parts[1];
      var year = parseInt(parts[2]);
      var hour = parseInt(parts[3]);
      var minute = parseInt(parts[4]);
      var second = parseInt(parts[5]);
      // Create the date object in GMT
      var date = new Date(
        Date.UTC(year, this.getMonthIndex(month), day, hour, minute, second)
      );
      // Convert to India Standard Time
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset() + 330);
      let modifiedfanDate = date;
      const msBetweenDates = Math.abs(
        modifiedfanDate.getTime() - currentDate.getTime()
      );
      const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
      this.checkhr = hoursBetweenDates <= 24 ? true : false;
      return this.checkhr ? data.fan : null;
    });
    let onedayActiveFans = this.fanDetails.filter((data) => data != null);
    let activeFan = [...new Set(onedayActiveFans)];
    this.activeFanId = activeFan.join(", ");
    this.errMsgDisplay =
      fanlistInProgress.length >= 1 && this.activeFanId.length >= 1
        ? true
        : false;
  }

  // Helper function to convert month abbreviation to index
  getMonthIndex(month: string): number {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.findIndex((m) => m === month);
  }

  ngAfterViewChecked() {
    this.tilesHeight();
  }

  hasFullPermission() {
    return sessionStorage.getItem("user") &&
      JSON.parse(sessionStorage.getItem("user")).user.addpAuthority == "FULL"
      ? true
      : false;
  }

  tilesHeight() {
    const addpDashboardContainer = this.el.nativeElement.getElementsByClassName(
      "addp-dashboard-container"
    );
    if (addpDashboardContainer.length) {
      if (window.innerWidth <= 1024) {
        addpDashboardContainer[0].style.height = "auto";
        addpDashboardContainer[0].classList.remove("height-set");
      } else {
        addpDashboardContainer[0].style.height =
          addpDashboardContainer[0].clientHeight + "px";
        addpDashboardContainer[0].classList.add("height-set");
      }
    }

    const deviceContainer = document.getElementsByClassName(
      "device-status-container"
    )[0];
    const fanContainer = document.getElementsByClassName(
      "fan-status-container"
    )[0];
    const reportContainer =
      document.getElementsByClassName("report-container")[0];

    if (!fanContainer && !reportContainer && deviceContainer) {
      addpDashboardContainer[0].style.height = "auto";
      addpDashboardContainer[0].classList.remove("height-set");
    }

    if (
      addpDashboardContainer[0] &&
      addpDashboardContainer[0].firstElementChild &&
      addpDashboardContainer[0].firstElementChild.firstElementChild
        .classList[1] !== "device-status-container"
    ) {
      if (addpDashboardContainer.length && window.innerWidth >= 1025) {
        addpDashboardContainer[0].style.height =
          addpDashboardContainer[0].clientHeight + "px";
        addpDashboardContainer[0].classList.add("height-set");
      }
    }
  }

  ngAfterViewInit() {
    if (!this.hasAddpPermission) {
      const perMapping =
        this.user.addpAuthority + "_" + this.user.fanSignedUpStatus;
      if (ENV_PORTAL === "fnabc") {
        this.permissionLevelMessage =
          ADDP_PERMISSION_MAPPING_FNABC[perMapping].message;
      } else {
        this.permissionLevelMessage =
          ADDP_PERMISSION_MAPPING[perMapping].message;
      }
    }
  }

  // ngDoCheck() {
  //   this.breadCrumbService.removeBreadCrumbs();
  //   this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
  //   //this.breadCrumbService.setCurrentBreadCrumb({ label: 'Home', routerLink: '/home' });
  //   this.breadCrumbService.setCurrentBreadCrumb({ label: 'AT&T Business Console Dashboard', routerLink: '/dashboard' });
  // }

  redirectToHome() {
    this.router.navigate(["/home"]);
  }
  buildForm(): void {
    this.searchUser = this.formBuilder.group({
      fullName: ["", [this.manageDashboardService.checkLength]],
    });
    this.validationService.validate(
      this.searchUser,
      this.formErrors,
      this.validationMessages
    );
  }

  assignUnassignWizard() {
    this.userWizardModel = new UserWizardModel();
    this.userWizardModel.previousUrl = "/dashboard";
    this.userWizardService.addAssignOrUnassignWizard(this.userWizardModel);
    this.utilityService.setSuccessMessage(null);
    this.router.navigate(["/manageUsers"]);
  }
  goToManage() {
    this.utilityService.setSuccessMessage(null);
    this.breadCrumbService.changeSessionSource("managedashboard");
    this.router.navigate(["/manage"]);
  }

  goToBulkUpload() {
    this.utilityService.setSuccessMessage(null);
    sessionStorage.setItem("bulk-previousRoute", "/dashboard");
    sessionStorage.setItem("bulk-sourcePreviousRoute", "/dashboard");
    this.stepIndicatorService.removeStep("bulkUsers");
    this.router.navigate(["/bulkUsers"]);
  }

  searchUsers(event, focusable) {
    this.reviewComponentSuccessMessageFlag = false;
    this.utilityService.setSuccessMessage(null);
    if (this.searchUser.value.fullName !== "") {
      this.pageLoaderService.setPageLoaderStatus(false);
      this.errorMsg = "";
      this.multipleUserFlag = false;
      const searchValue = this.searchUser.value.fullName;
      const serviceUrl =
        this.utilityService.getEnvConfig().searchUsersUrl +
        this.user.companyId +
        "/employees/textSearch";
      let requestBody = {};
      requestBody["searchValue"] = searchValue;
      requestBody["fetchCriteria"] = { limit: 20, offset: 0 };
      this.manageDashboardService
        .searchUserService(serviceUrl, requestBody)
        .subscribe(
          (response) => {
            this.searchResponse = response.dataJson;
            if (this.searchResponse !== undefined) {
              if (this.searchResponse.length > 1) {
                this.multipleUserFlag = true;
              }
              this.errorMsgCheck = true;
              this.usersPopup = true;
              setTimeout(() => {
                document.getElementById("usersPopup");
              });
              this.pageLoaderService.setPageLoaderStatus(true);
              setTimeout(() => {
                document.getElementById("modalHeading").focus();
              });
            } else {
              this.errorMsgCheck = false;
              this.usersPopup = true;
              setTimeout(() => {
                document.getElementById("usersPopup");
              });
              this.pageLoaderService.setPageLoaderStatus(true);
              setTimeout(() => {
                document.getElementById("modalHeading").focus();
              });
            }
          },
          (error) => {
            this.pageLoaderService.setPageLoaderStatus(true);
            this.adobeAnalyticsService.CreateSeriveAlertProperties(
              error.status,
              error.statusText,
              "formResponse"
            );
            this.handleError(error, "FETCH_USERS");
          }
        );
    }
  }

  displayUserDetails(data, index) {
    this.utilityService.setSuccessMessage(null);
    this.pageLoaderService.setPageLoaderStatus(false);
    this.id = data.clientId;
    this.requestUserSummaryModel = new RequestUserSummaryModel();
    this.userSummaryDataService.setUserManageToSession(this.id, {
      productName: "Workspace",
    });
    const userNewObj = this.userSummaryDataService.getUserManageFromSession(
      this.id
    );
    userNewObj.user_info = new UserSummaryModel();
    userNewObj.user_info.contactNumber = this.searchResponse[index].phoneNumber;
    userNewObj.user_info.displayName = this.searchResponse[index].displayName;
    userNewObj.user_info.email = this.searchResponse[index].email;
    userNewObj.user_info.firstName = this.searchResponse[index].firstName;
    userNewObj.user_info.id = this.searchResponse[index].clientId;
    userNewObj.user_info.lastName = this.searchResponse[index].lastName;
    userNewObj.userSummaryProductModelArr = [];
    const url =
      this.utilityService.getEnvConfig().getManageUserCtnUrl +
      this.user.companyId +
      "/licenses/";
    this.requestUserSummaryModel.employeeClientIdList.push(this.id);
    this.requestUserSummaryModel.fetchCriteria = {
      class: "API::SepPagingLoadConfig",
      limit: 20,
      offset: 0,
      sortField: "id",
    };
    this.userSummaryDataService
      .getInfo(url, this.requestUserSummaryModel)
      .subscribe(
        (respobj) => {
          if (respobj !== undefined && respobj.dataJson !== undefined) {
            this.errorMsg = "";
            this.formInputData = this.userSummaryDataService.formatData(
              respobj,
              userNewObj.user_info
            );
            this.user_manage_info = new UserManageModel();
            this.user_manage_info =
              this.userSummaryDataService.getUserManageFromSession(this.id);
            const new_obj =
              this.userSummaryDataService.getUserManageFromSession(this.id);
            new_obj.user_info = new UserSummaryModel();
            new_obj.user_info = this.formInputData.userInfo;
            new_obj.userSummaryProductModelArr = [];
            new_obj.userSummaryProductModelArr =
              this.formInputData.userSummaryProductModelArr;
            this.userSummaryDataService.setUserManageToSession(
              this.id,
              new_obj
            );
            document.body.classList.remove("modal-open");
            removeAriaHidden();
            this.pageLoaderService.setPageLoaderStatus(true);
            this.router.navigate(["user/summary/" + this.id]);
          } else {
            this.focusabbleElements = undefined;
            this.usersPopup = false;
            this.userSummaryDataService.setUserManageToSession(
              this.id,
              userNewObj
            );
            document.body.classList.remove("modal-open");
            removeAriaHidden();
            this.pageLoaderService.setPageLoaderStatus(true);
            this.router.navigate(["user/summary/" + this.id]);
          }
        },
        (error) => {
          this.adobeAnalyticsService.CreateSeriveAlertProperties(
            error.status,
            error.statusText,
            "formResponse"
          );
          this.handleError(error, "FETCH_USER_DETAILS");
        }
      );
  }

  searchAgain() {
    this.usersPopup = false;
    document.body.classList.remove("modal-open");
    removeAriaHidden();
    this.buildForm();
    setTimeout(() => {
      this.fullNameElement.nativeElement.focus();
    });
  }

  cancel(event) {
    this.focusabbleElements = undefined;
    this.usersPopup = false;
    document.body.classList.remove("modal-open");
    removeAriaHidden();
    setTimeout(() => {
      this.searchNameElement.nativeElement.focus();
    });
  }

  btnAction(event) {
    this.focusabbleElements = undefined;
    if (event.target) {
      event.target.focus();
    }
  }

  loadFocustelements() {
    if (this.usersPopup) {
      document.body.classList.add("modal-open");
      initAriaHidden();
      if (!this.focusabbleElements) {
        const focusableEls = this.searchElement.nativeElement.querySelectorAll(
          "a[href], area[href]," +
          ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex= "0"]'
        );
        this.focusabbleElements = Array.prototype.slice.call(focusableEls);
        this.focusabbleElements[0].focus();
      }
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(event);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

  getReport(type) {
    this.manageDashboardService.dashboardReport(
      this.utilityService.getEnvConfig().getStatsReport,
      type
    );
    this.pageLoaderService.setPageLoaderStatus(true);
  }
  reviewSuccess() {
    if (
      sessionStorage.getItem("previousRoute") === "/manageUsers/review" &&
      this.utilityService.getSuccessMessage() != null
    ) {
      this.reviewComponentSuccessMessageFlag = true;
      this.reviewComponentSuccessMessage =
        this.utilityService.getSuccessMessage();
      this.utilityService.loadFocusOnTop();
    } else {
      this.reviewComponentSuccessMessageFlag = false;
    }
  }

  updateFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = "NONE";
    if (fansSummary) {
      const signedUpFansCount = fansSummary.filter((f) => {
        return f.status === "ACTIVE" || f.status === "READY_TO_SETUP";
      }).length;
      const notSignedUpFansCount = fansSummary.filter((f) => {
        return f.status === "PROCESSING" || f.status === "AWAITING_SIGNUP";
      }).length;
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = "SOME";
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = "ALL";
      } else {
        fanSignedUpStatus = "NONE";
      }
    }
    this.user.fanSignedUpStatus = fanSignedUpStatus;
    this.authenticationService.setUser(this.user);
  }

  initPage(scenarios?) {
    if (typeof scenarios !== "undefined") {
      this.companyId = scenarios;
    }

    this.showData = false;
    this.readyToSetup = false;
    // this.pageLoaderService.setPageLoaderStatus(false);
    let processingFans = JSON.parse(
      sessionStorage.getItem("processingFanList")
    );
    this.processingFansCount = JSON.parse(
      sessionStorage.getItem("processingFanList")
    )
      ? processingFans.length: 0;
    
    

    this.chartData = {};
    this.legendData = {};
    this.chartLabel = {};
    this.manageDeploymentMixedFans = false;
    this.manageDashboardService.getFanStatusSummary(this.companyId).subscribe(
      (respobj) => {
        // if(respobj.noOfFans == 0 && respobj.noOfDevices == 0 && respobj.allFansInEligible === true){
        //   this.user.fanSignedUpStatus = 'Unknown';
        //   this.showUnknown = true;
        //   this.showNotEligible = false;
        // }

        if(respobj?.fanInfoList && respobj?.fanInfoList.length > 0){
          this.processingFanList_ = respobj?.fanInfoList.filter((f) => {
            return (f.accountStatus === "PROCESSING" || f.accountStatus === "SIGNUP_INPROGRESS");
          });

          if(this.processingFansCount == 0){
            this.processingFansCount = this.processingFanList_.length;
          }
      
          if (this.processingFansCount >= 1) {
            this.processingFansFlag = true;
          }
        }

        sessionStorage.setItem(
          "fanInfoList",
          JSON.stringify(respobj.fanInfoList)
        );

        if(respobj?.fanInfoList && respobj?.fanInfoList.length > 0){
          if(respobj.initialSignupStatus === "Not Signed Up"){
            let enrollStatus_ = respobj?.fanInfoList.map((elm) => elm.accountStatus);
              let fanListData = new Set(enrollStatus_);
              if(fanListData.has("SIGNUP_INPROGRESS") && fanListData.has("ACTIVE")){
                this.showDeviceInventoryIfNotSignedUp = true;
              }else{
                this.showDeviceInventoryIfNotSignedUp = false;
              }
          }
        }
        
        this.checkErrorMsg();

        // let signupActiveFanList = [];
        // if (respobj.fansSummary.length > 0) {
        //   let signupFanSum = respobj.fansSummary;
        //       for (let i = 0; i < signupFanSum.length; i++) {
        //         if (signupFanSum[i].status == "ACTIVE") {
        //           for (let j = 0; j < signupFanSum[i].count; j++) {
        //             signupActiveFanList.push(signupFanSum[i].fans[j]);
        //           }
        //         }
        //       }
        //     }
        //     sessionStorage.setItem('signupActiveFanList', JSON.stringify(signupActiveFanList));
        //     this.activeSigedupFans = signupActiveFanList;

        // if(ENV_PORTAL.toUpperCase() === "DMPADMIN") {
        //   if (sessionStorage.getItem('iv-user') && this.sendActiveCount === 0) {
        //     const ivuser = sessionStorage.getItem('iv-user');
        //     this.sendActiveCount++
        //     let fanSessionData = {
        //       sessionID: sessionStorage.getItem('sessionId'),
        //       fan: "",
        //     };
        //     let signupActiveFanList = this.activeSigedupFans;
        //     signupActiveFanList = signupActiveFanList?.filter((item, index) => {
        //       return signupActiveFanList.indexOf(item) === index;
        //     });
        //     for (let i = 0; i < signupActiveFanList?.length; i++) {
        //       fanSessionData.fan = signupActiveFanList[i];
        //       this.homeService.triggerActiveFans(fanSessionData)
        //         .subscribe((resp) => {
        //         }, error => {
        //           this.handleError(error);
        //         });;
        //     }
        //   }
        // }

        if (respobj.fanInfoList && respobj.fanInfoList.length > 0 && respobj.noOfFans == 1) {
          // respobj.fanInfoList.forEach((elm) => {
          //   this.emmProductCodeForFan = elm.emmProductCode;
          //   this.signupStatus = elm.accountStatus;

          //   if(this.emmProductCodeForFan == "DMPAABM" && this.signupStatus == "SIGNUP_INPROGRESS") {
          //     this.isSingleABMFE = true;
          //   }
          //   else {
          //     this.isSingleABMFE = false;
          //   }
          // });
          let data = new Set(respobj.fanInfoList.map((elm) => elm.accountStatus));
          if ((data.has("SIGNUP_INPROGRESS") && data.has("INACTIVE") && data.has("ACTIVE")) || (data.has("SIGNUP_INPROGRESS") && data.has("ACTIVE")) || (data.has("INACTIVE") && data.has("ACTIVE"))) {
            this.isSingleABMFE = false;
          } else if ((data.has("SIGNUP_INPROGRESS") && data.has("INACTIVE")) || (data.size == 1 && data.has("SIGNUP_INPROGRESS"))) {
            this.isSingleABMFE = true;
          }
        }

        if (respobj.fansSummary && respobj.fansSummary.length > 0) {
          let signupFanSum = respobj.fansSummary;
          let signupFanList = [];
          let processingFanList = [];
          for (let i = 0; i < signupFanSum.length; i++) {
            if (signupFanSum[i].status == "AWAITING_SIGNUP") {
              for (let j = 0; j < signupFanSum[i].count; j++) {
                signupFanList.push(signupFanSum[i].fans[j]);
              }
            }
          }
          sessionStorage.setItem(
            "signupFanList",
            JSON.stringify(signupFanList)
          );
          //for 'processing' fans
          for (let i = 0; i < signupFanSum.length; i++) {
            if (signupFanSum[i].status == "PROCESSING") {
              for (let j = 0; j < signupFanSum[i].count; j++) {
                //processingFanList.push(signupFanSum[i].fans[j]);
                //getting fan info of 'processing' fan to store in session storage
                for (let k = 0; k < respobj.fanInfoList.length; k++) {
                  if (signupFanSum[i].fans[j] === respobj.fanInfoList[k].fan) {
                    processingFanList.push(respobj.fanInfoList[k]);
                  }
                }
              }
            }
          }
          sessionStorage.setItem(
            "processingFanList",
            JSON.stringify(processingFanList)
          );
        }
        this.efotaFansSummary = respobj.efotaFansSummary;
        if (this.efotaFansSummary) {
          for (let i = 0; i < this.efotaFansSummary.length; i++) {
            if (this.efotaFansSummary[i].status == "ACTIVE") {
              this.fansActiveCount = this.efotaFansSummary[i].count;
            }
            if (this.efotaFansSummary[i].status == "AWAITING_SIGNUP") {
              this.fansNotSignedUpCount = this.efotaFansSummary[i].count;
            }
          }
          if (this.efotaFansSummary.length > 2) {
            this.isEfotaAccountsTileLarge = true;
          }
        }
        this.isEfotaEnrolledFanList =
          this.efotaFansSummary && this.efotaFansSummary.length > 0
            ? true
            : false;
        this.isEfotaNotEnrolledFanList =
          respobj.efotaNotEnrolledFanList &&
            respobj.efotaNotEnrolledFanList.length > 0
            ? true
            : false;
        if (
          !this.isFullPermissionUser ||
          (this.isFullPermissionUser && this.fansNotSignedUpCount === 0)
        ) {
          this.isAddAccounts = true;
        }
        if (this.fansNotSignedUpCount > 0) {
          this.hasNotSignedUpFans = true;
        }
        if (
          respobj.initialSignupStatus === "Not Signed Up" &&
          this.processingFansCount >= 1
        ) {
          this.buildChartData(
            respobj.initialSignupStatus,
            respobj.fanInfoList,
            "accounts",
            this.stringAccount,
            respobj.fansSummary
          );
        }
        if (this.efotaFansSummary) {
          this.buildChartData(
            respobj.initialSignupStatus,
            respobj.efotaFansSummary,
            "efotaAccounts",
            this.stringAccount,
            ""
          );
        }

        this.changeRequests = respobj.efotaChangeRequestSummary;
        this.buildChartData(
          "all",
          this.changeRequests,
          "changeRequest",
          "Change Requests",
          ""
        );
        this.buildChartData("", "", "reportRequest", "New Reports", "");

        if (this.user.fanSignedUpStatus === "Error") {
          sessionStorage.setItem(
            "initialSignupStatus",
            respobj.initialSignupStatus
          );
          sessionStorage.setItem("noOfDevice", respobj.noOfDevices);
          if (respobj.fansSummary.length > 0) {
            let signupFanSum = respobj.fansSummary;
            let signupFanList = [];
            let processingFanList = [];
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "AWAITING_SIGNUP") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem(
              "signupFanList",
              JSON.stringify(signupFanList)
            );
            //for 'processing' fans
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "PROCESSING") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  //processingFanList.push(signupFanSum[i].fans[j]);
                  //getting fan info of 'processing' fan to store in session storage
                  for (let k = 0; k < respobj.fanInfoList.length; k++) {
                    if (
                      signupFanSum[i].fans[j] === respobj.fanInfoList[k].fan
                    ) {
                      processingFanList.push(respobj.fanInfoList[k]);
                    }
                  }
                }
              }
            }
            sessionStorage.setItem(
              "processingFanList",
              JSON.stringify(processingFanList)
            );
          }
          if (!respobj.efotaFansSummary) {
            sessionStorage.setItem("efotaEnrolledFanList", "[]");
          } else {
            let efotaFansSum = respobj.efotaFansSummary;
            let efotaEnrolledFanList = [];
            for (let i = 0; i < efotaFansSum.length; i++) {
              if (efotaFansSum[i].status == "ACTIVE") {
                for (let j = 0; j < efotaFansSum[i].count; j++) {
                  efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem(
              "efotaEnrolledFanList",
              JSON.stringify(efotaEnrolledFanList)
            );
          }
          if (!respobj.efotaNotEnrolledFanList) {
            sessionStorage.setItem("efotaNotEnrolledFanList", "[]");
            sessionStorage.setItem("efotaEnrollmentInfo", "[]");
          } else {
            sessionStorage.setItem(
              "efotaEnrollmentInfo",
              JSON.stringify(respobj.efotaEnrollmentInfo)
            );
            sessionStorage.setItem(
              "efotaNotEnrolledFanList",
              JSON.stringify(respobj.efotaNotEnrolledFanList)
            );
          }
          if (respobj.allFansInEligible === true) {
            this.user.fanSignedUpStatus = "NotEligible";
            this.showNotEligible = true;
          } else {
            if (this.user) {
              this.updateFanSignedUpStatus(respobj.fansSummary);
            }
            if (
              respobj.productCode !== null &&
              respobj.productCode !== undefined
            ) {
              this.mdmDetails.productCode = respobj.productCode;
              this.mdmDetails.latestAccountType =
                respobj.recentlyEnrolledProduct;
              if (this.mdmDetails.productCode === "ADDPMDM") {
                this.mdmDetails.ibmEmmAccountId = respobj.ibmEmmAccountId;
                let productDetails = {
                  emmProductCode: "",
                  selectedAccID: "",
                  signupEmmStatus: "",
                };
                productDetails.emmProductCode = "ADDPMDM";
                productDetails.selectedAccID = respobj.ibmEmmAccountId;
                productDetails.signupEmmStatus = "revised";
                sessionStorage.setItem(
                  "manage-product",
                  JSON.stringify(productDetails)
                );
              } else {
                if (
                  respobj.googleEmmAccountId !== null &&
                  respobj.googleEmmAccountId !== undefined
                ) {
                  this.mdmDetails.googleEmmAccountId =
                    respobj.googleEmmAccountId;
                }
                if (
                  respobj.samsungEmmAccountId !== null &&
                  respobj.samsungEmmAccountId !== undefined
                ) {
                  this.mdmDetails.samsungEmmAccountId =
                    respobj.samsungEmmAccountId;
                }
                if (
                  respobj.fanInfoList !== null &&
                  respobj.fanInfoList !== undefined
                ) {
                  sessionStorage.setItem(
                    "fanInfoList",
                    JSON.stringify(respobj.fanInfoList)
                  );
                }
              }
              sessionStorage.setItem(
                "mdmDetails",
                JSON.stringify(this.mdmDetails)
              );
            }
          }
        }
        if (respobj.allFansInEligible === true) {
          this.fanStatus = respobj;
          this.showData = true;
          this.pageLoaderService.setPageLoaderStatus(true);
        } else if (this.user.fanSignedUpStatus !== "Error") {
          sessionStorage.setItem("noOfDevice", respobj.noOfDevices);
          this.fanStatus = respobj;
          this.updateFanSignedUpStatus(this.fanStatus.fansSummary);
          if (
            respobj.productCode !== null &&
            respobj.productCode !== undefined
          ) {
            this.mdmDetails.productCode = respobj.productCode;
            this.mdmDetails.latestAccountType = respobj.recentlyEnrolledProduct;
            if (respobj.productCode === "ADDPMDM") {
              this.mdmDetails.ibmEmmAccountId = respobj.ibmEmmAccountId;
              let productDetails = {
                emmProductCode: "",
                selectedAccID: "",
                signupEmmStatus: "",
              };
              productDetails.emmProductCode = "ADDPMDM";
              productDetails.selectedAccID = respobj.ibmEmmAccountId;
              productDetails.signupEmmStatus = "revised";
              sessionStorage.setItem(
                "manage-product",
                JSON.stringify(productDetails)
              );
            } else {
              this.oemStatus = true;
              if (
                respobj.googleEmmAccountId !== null &&
                respobj.googleEmmAccountId !== undefined
              ) {
                this.mdmDetails.googleEmmAccountId = respobj.googleEmmAccountId;
              }
              if (
                respobj.samsungEmmAccountId !== null &&
                respobj.samsungEmmAccountId !== undefined
              ) {
                this.mdmDetails.samsungEmmAccountId =
                  respobj.samsungEmmAccountId;
              }
              if (
                (respobj.samsungEmmAccountId !== null &&
                  respobj.samsungEmmAccountId !== undefined) ||
                (respobj.googleEmmAccountId !== undefined &&
                  respobj.googleEmmAccountId !== null)
              ) {
                this.mdmDetails.samsungEmmAccountId =
                  respobj.samsungEmmAccountId;
                this.mdmDetails.googleEmmAccountId = respobj.googleEmmAccountId;
              }
              if (
                respobj.fanInfoList !== null &&
                respobj.fanInfoList !== undefined
              ) {
                sessionStorage.setItem(
                  "fanInfoList",
                  JSON.stringify(respobj.fanInfoList)
                );
              }
            }
            sessionStorage.setItem(
              "mdmDetails",
              JSON.stringify(this.mdmDetails)
            );
          }
          this.eligibleFanCount = 0;
          this.FanLegendCount = 0;
          if (this.fanStatus.fansSummary) {
            this.fanStatus.fansSummary.filter((f) => {
              if (
                f.count &&
                (f.status === "AWAITING_SIGNUP" || f.status === "ACTIVE")
              ) {
                // this.eligibleFanCount += f.count;
                this.FanLegendCount++;
              }
            });

            this.eligibleFanCount = this.fanStatus.noOfFans;
          }
          if (this.eligibleFanCount === 1) {
            this.stringAccount = "account";
          }
          else {
            this.stringAccount = "accounts";
          }
          let awaitingSignup = 0;
          if (
            respobj.fansSummary !== null &&
            respobj.fansSummary !== undefined
          ) {
            let fanCounts = 0, uniqFans = new Set();
            this.fanStatus.fansSummary.filter((f) => {
              if (f.status === "AWAITING_SIGNUP") {
                awaitingSignup += f.count;
              }

              if(f.status === "PROCESSING"){
                uniqFans.add(f.fans);
                awaitingSignup += uniqFans.size;
              }
            });
          }
          this.dashboardData.manageDeployment.firstTimeUser =
            this.dashboardData.manageDeployment.firstTimeUser.replace(
              "<noOfFans>",
              awaitingSignup
            );
          this.dashboardData.manageDeployment.firstTimeUser =
            this.dashboardData.manageDeployment.firstTimeUser.replace(
              "<xxx>",
              this.stringAccount
            );
          this.dashboardData.manageDeployment.deviceEnrolledContent =
            this.dashboardData.manageDeployment.deviceEnrolledContent.replace(
              "<noOfFans>",
              this.eligibleFanCount
            );

          this.dashboardData.manageDeployment.setupIncompleteContent =
            this.dashboardData.manageDeployment.setupIncompleteContent.replace(
              "<xxx>",
              this.stringAccount
            );
          this.dashboardData.manageDeployment.setupCompleteContent =
            this.dashboardData.manageDeployment.setupCompleteContent.replace(
              "<noOfFans>",
              this.eligibleFanCount
            );
          this.dashboardData.manageDeployment.setupCompleteContent =
            this.dashboardData.manageDeployment.setupCompleteContent.replace(
              "<xxx>",
              this.stringAccount
            );
          this.dashboardData.deviceInventory.setupCompleted =
            this.dashboardData.deviceInventory.setupCompleted.replace(
              "<noOfDevices>",
              respobj.noOfDevices
            );
          if (this.efotaFansSummary) {
            this.dashboardData.efotaAccounts.description =
              this.dashboardData.efotaAccounts.description.replace(
                "<noOfEfotaFans>",
                this.fansNotSignedUpCount
              );
            this.dashboardData.efotaAccounts.description =
              this.dashboardData.efotaAccounts.description.replace(
                "<xxx>",
                this.stringAccount
              );
          }
          if (this.fansNotSignedUpCount == 1) {
            this.dashboardData.efotaAccounts.description =
              this.dashboardData.efotaAccounts.description.replace(
                "accounts",
                "account"
              );
          }
          if (respobj.noOfFans <= 1) {
            // Changing text for singular fans and devices
            this.dashboardData.manageDeployment.firstTimeUser =
              this.dashboardData.manageDeployment.firstTimeUser.replace(
                "accounts",
                "account"
              );
            this.dashboardData.manageDeployment.deviceEnrolledContent =
              this.dashboardData.manageDeployment.deviceEnrolledContent.replace(
                "devices",
                "device"
              );
            this.dashboardData.manageDeployment.setupIncompleteContent =
              this.dashboardData.manageDeployment.setupIncompleteContent.replace(
                "accounts",
                "account"
              );

            this.appleInstalled =
              this.dashboardData.appleCertificate[
              this.fanStatus.appleCertificate
              ];
            this.dashboardData.deviceInventory.setupCompleted =
              this.dashboardData.deviceInventory.setupCompleted.replace(
                "devices",
                "device"
              );
          }
          if (this.eligibleFanCount <= 1) {
            // Changing text for singular fans and devices
            this.dashboardData.manageDeployment.setupCompleteContent =
              this.dashboardData.manageDeployment.setupCompleteContent.replace(
                "accounts",
                "account"
              );
          }

          if (
            respobj.fansSummary !== null &&
            respobj.fansSummary !== undefined
          ) {
            this.checkAwaitingSetUp(respobj.fansSummary);
          }
          if (respobj.initialSignupStatus === "Signed Up") {
            this.accountDetails = JSON.parse(
              sessionStorage.getItem("mdmDetails")
            );
            this.readyToSetupCount = 0;
            //this.fanStatus.fansSummary.filter((f) => { if (f.status === 'READY_TO_SETUP') { this.readyToSetupCount = f.count; } });
            this.dashboardData.manageDeployment.firstTimeUser =
              this.dashboardData.manageDeployment.firstTimeUser.replace(
                "<noOfFans>",
                this.eligibleFanCount + this.processingFansCount
              );
            this.buildChartData(
              respobj.initialSignupStatus,
              respobj.fanInfoList,
              "accounts",
              this.stringAccount,
              respobj.fansSummary
            );
          }
          if (respobj.initialSignupStatus === "Completed") {
            this.accountDetails = JSON.parse(
              sessionStorage.getItem("mdmDetails")
            );
            this.buildChartData(
              respobj.initialSignupStatus,
              respobj.fanInfoList,
              "accounts",
              this.stringAccount,
              respobj.fansSummary
            );
          }

          if (respobj.initialSignupStatus === "PROCESSING") {
            if (respobj.noOfFans === 1) {
              this.loaderOtherScenario = true;
              this.manageDashboardService
                .getFANList()
                .subscribe((resp) => {
                  this.fanList = resp.revisedFanList[0];
                  sessionStorage.setItem(
                    "selectedFAN",
                    this.fanList.fanId
                  );
                });
            }
          }

          if (
            (respobj.initialSignupStatus === "Completed" &&
            (respobj.deviceEnrolledStatus === "Completed" ||
              respobj.deviceEnrolledStatus === "Future Enrollment")) || this.showDeviceInventoryIfNotSignedUp
          ) {
            this.accountDetails = JSON.parse(
              sessionStorage.getItem("mdmDetails")
            );
            if (this.accountDetails.productCode === "ADDPZTE") {
              this.loaderOtherScenario = false;
              this.manageDeploymentMixedFans = true;
              this.manageDashboardService
                .getDevicesCount(this.companyId)
                .subscribe((respobjec) => {
                  this.dashboardData.deviceInventory.setupOemCompleted =
                    this.dashboardData.deviceInventory.setupOemCompleted.replace(
                      /^\S+/,
                      respobjec.noOfDevices
                    );
                  if (respobjec.noOfDevices <= 1) {
                    this.dashboardData.deviceInventory.setupOemCompleted =
                      this.dashboardData.deviceInventory.setupOemCompleted.replace(
                        "devices",
                        "device"
                      );
                  }
                  this.buildDeviceChartData(
                    respobjec.deviceInventoryEnrollSummary,
                    "devices",
                    "devices",
                    respobj.deviceEnrolledStatus
                  );
                  if (respobj.noOfFans === 1) {
                    this.loaderOtherScenario = false;
                    this.manageDashboardService
                      .getFANList()
                      .subscribe((resp) => {
                        this.fanList = resp.revisedFanList[0];
                        sessionStorage.setItem(
                          "selectedFAN",
                          this.fanList.fanId
                        );
                      });
                  }
                });
            } else {
              this.dashboardData.deviceInventory.setupOemCompleted =
                this.dashboardData.deviceInventory.setupOemCompleted.replace(
                  "<noOfDevices>",
                  respobj.noOfDevices
                );
              if (respobj.noOfDevices <= 1) {
                this.dashboardData.deviceInventory.setupOemCompleted =
                  this.dashboardData.deviceInventory.setupOemCompleted.replace(
                    "devices",
                    "device"
                  );
              }
              this.buildDeviceChartData(
                respobj.deviceInventoryEnrollSummary,
                "devices",
                "devices",
                respobj.deviceEnrolledStatus
              );
              if (respobj.noOfFans === 1) {
                this.loaderOtherScenario = false;
                this.manageDashboardService.getFANList().subscribe((resp) => {
                  this.fanList = resp.revisedFanList[0];
                  sessionStorage.setItem("selectedFAN", this.fanList.fanId);
                });
              }
            }
            // this.pageLoaderService.setPageLoaderStatus(true);
          }
          if (respobj.deviceEnrolledStatus === "Error") {
            this.buildErrorChartData();
          }
          if (this.loaderOtherScenario) {
            this.pageLoaderService.setPageLoaderStatus(true);
          }
          this.showData = true;
        }
      },
      (error) => this.handleError(error, "FETCH_FANSUMMARY")
    );

  }
  handleError(error, type?) {
    if (type !== undefined && type === "FETCH_APPLECERT_STATUS") {
      this.errorMsg = ERRCODES["FETCH_APPLECERT_STATUS"];
    } else {
      this.errorMsg = ERRCODES["genericErrorMessage"];
    }
    this.apiError = true;
    this.pageLoaderService.setPageLoaderStatus(true);
  }

  navigate(route) {
    if (route === "/reports") {
      this.initReportPopupModal();
    } else {
      this.router.navigate([route]);
    }
  }

  buildErrorChartData() {
    this.chartData["error"] = [];
    this.chartLabel["error"] = "devices";
    const temp = {
      value: 0,
      color: "#ccc",
      legend: "Error",
    };
    this.chartData["error"].push(temp);
  }

  buildChartData(initialSignupStatus, fanDetails, type, label, fanSummary) {
    if (
      type === "accounts" &&
      ((initialSignupStatus === "Completed" &&
        this.mdmDetails !== null &&
        this.mdmDetails.productCode === "ADDPMDM") ||
        (initialSignupStatus === "Signed Up" &&
          this.mdmDetails !== null &&
          this.mdmDetails.productCode === "ADDPMDM"))
    ) {
      this.getAppleCertificateStatus();
    }

    if (type == "accounts") {
      this.chartData[type] = [];
      // this.legendData[type] = { left: [], right: [] };
      this.legendData[type] = [];
      this.chartLabel[type] = label;

      let notEnrollCount = 0;

      if (fanSummary) {
        let notEnrollArr = fanSummary.filter(
          (x) => x.status === "AWAITING_SIGNUP"
        );
        if (notEnrollArr && notEnrollArr.length > 0) {
          notEnrollCount = notEnrollArr[0].count;
        }
      }

      let activeFans = fanDetails.filter((f) => {
        return f.accountStatus === "ACTIVE";
      });
      let signupInprogressFans = fanDetails.filter((f) => {
        return (f.accountStatus === "PROCESSING" || f.accountStatus === "SIGNUP_INPROGRESS");
      });
      let duplicateFan = activeFans.filter(c => signupInprogressFans.map(s => s.fan).includes(c.fan))
      const countObj = {};
      const countPendingObj = {};
      this.disableRemoveLink = this.checkABMFEPEnding(fanDetails);

      fanDetails.map(function (item) {
        if (countObj.hasOwnProperty(item.fan)) {
          if (item.accountStatus === "ACTIVE") {
            countObj[item.fan]++;
          }
        } else {
          if (item.accountStatus === "ACTIVE") {
            countObj[item.fan] = 1;
          }
          if ((item.accountStatus === "SIGNUP_INPROGRESS" && item.emmProductCode === "DMPAABM") && (duplicateFan.length < 1)) {
            countPendingObj[item.fan] = 1;
          }
        }
      });

      const countArr = Object.values(countObj);
      const countPendingArr = Object.values(countPendingObj);
      let notEnrolledProgramCount = 0;
      let enrollSingleProgramCount = 0;
      let enrollMultipleProgramsCount = 0;
      let enrollSinglePendingProgramsCount = 0;
      let enrollMultiplePendingProgramsCount = 0;

      countArr.map(function (item) {
        if (item == 1) {
          enrollSingleProgramCount++;
        } else if (item == 2) {
          enrollMultipleProgramsCount++;
        }
      });
      countPendingArr.map(function (item: any) {
        if (item == 1) {
          enrollSinglePendingProgramsCount++;
        }
        else if (item > 1) {
          enrollMultiplePendingProgramsCount++;
        }
      });

      this.notEnrolledProgram = notEnrollCount;
      this.enrollSingleProgram = enrollSingleProgramCount;
      this.enrollMultiplePrograms = enrollMultipleProgramsCount;
      this.enrollPendingProgram = enrollSinglePendingProgramsCount;
      this.enrollMultiPendingPrograms = enrollMultiplePendingProgramsCount

      if (this.notEnrolledProgram > 0) {
        const chartConfig1 = CHART_CONFIG["NOT_ENROLLED"];
        const temp1: DonutChartModel = {
          value: this.notEnrolledProgram,
          color: chartConfig1.color,
          legend: this.notEnrolledProgram + " " + chartConfig1.label,
        };
        this.chartData[type].push(temp1);
      }
      if (this.enrollPendingProgram > 0) {
        const chartConfig1 = CHART_CONFIG["PROCESSING"];
        const temp3: DonutChartModel = {
          value: this.enrollPendingProgram,
          color: chartConfig1.color,
          legend: this.enrollPendingProgram + " " + chartConfig1.label,
        };
        this.chartData[type].push(temp3);
      }
      if (this.enrollMultiPendingPrograms > 0) {
        const chartConfig1 = CHART_CONFIG["PROCESSING"];
        const temp3: DonutChartModel = {
          value: this.enrollMultiPendingPrograms,
          color: chartConfig1.color,
          legend: this.enrollMultiPendingPrograms + " " + chartConfig1.label,
        };
        this.chartData[type].push(temp3);
      }

      if (this.enrollSingleProgram > 0) {
        const chartConfig2 = CHART_CONFIG["ENROLLED_SINGLE_PROGRAM"];
        const temp2: DonutChartModel = {
          value: this.enrollSingleProgram,
          color: chartConfig2.color,
          legend: this.enrollSingleProgram + " " + chartConfig2.label,
        };
        this.chartData[type].push(temp2);
      }

      if (this.enrollMultiplePrograms > 0) {
        const chartConfig3 = CHART_CONFIG["ENROLLED_MULTIPLE_PROGRAMS"];
        const temp3: DonutChartModel = {
          value: this.enrollMultiplePrograms,
          color: chartConfig3.color,
          legend: this.enrollMultiplePrograms + " " + chartConfig3.label,
        };
        this.chartData[type].push(temp3);
      }
      console.log("this.chartData==>", this.chartData);
      this.legendData[type] = this.chartData[type];
    }

    if (type == "changeRequest") {
      this.chartData[type] = [];
      this.legendData[type] = { left: [], right: [] };
      this.chartLabel[type] = label;
      if (this.eligibleFanCount >= 1) {
        fanDetails = fanDetails.filter((o) => Object.keys(o).length);
        fanDetails.forEach((d, i) => {
          const chartConfig = EFOTA_CHART_CONFIG[d.status];
          const temp: DonutChartModel = {
            value: d.count,
            color: chartConfig.color,
            legend: d.count + chartConfig.label,
          };
          if (d.count) {
            this.chartData[type].push(temp);
            this.legendData[type][
              fanDetails.length / 2 > i ? "left" : "right"
            ].push(temp);
          }
        });
      }
    }

    if (type == "reportRequest") {
      this.chartData[type] = [];
      const chartConfig = EFOTA_CHART_CONFIG["noOfReports"];
      this.chartLabel[type] = label;
      const temp: DonutChartModel = {
        value: parseInt(this.noOfReports),
        color: chartConfig.color,
        legend: "",
      };
      if (this.noOfReports !== "0") {
        this.chartData[type].push(temp);
      }
    }
  }

  checkABMFEPEnding(fansSummary: any) {
    if (fansSummary && fansSummary.length > 0) {
      // //check Processing, Active and awaiting_setup fanlist for disable change for ABM FE pending
      // if((fansSummary.length == 1 && fansSummary[0].status == "PROCESSING") || (fansSummary.length == 1 && fansSummary[0].status == "READY_TO_SETUP") || (fansSummary.length == 1 && fansSummary[0].status == "AWAITING_SIGNUP")){
      //   return true;
      // }else {
      //   let data = fansSummary.map((elm) => elm.status);
      //   console.log("all status===>", data);
      //   if ((data.indexOf("PROCESSING") != -1 && data.indexOf("AWAITING_SIGNUP") != -1 && data.indexOf("ACTIVE") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("ACTIVE") != -1 && data.indexOf("AWAITING_SIGNUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("ACTIVE") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("ACTIVE") != -1)){
      //       return false;
      //   }else if((data.indexOf("PROCESSING") != -1 && data.indexOf("AWAITING_SIGNUP") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("READY_TO_SETUP") != -1) || (data.indexOf("PROCESSING") != -1 && data.indexOf("AWAITING_SIGNUP") != -1) || (data.indexOf("READY_TO_SETUP") != -1 && data.indexOf("AWAITING_SIGNUP") != -1)) {
      //       return true;
      //   }else {
      //       return false;
      //   }
      // }
      //check status ACTIVE, INACTIVE, SIGNUP_INPROGRESS
      let data = new Set(fansSummary.map((elm) => elm.accountStatus));

      if ((data.has("ACTIVE") && data.has("SIGNUP_INPROGRESS") && data.has("INACTIVE")) || (data.has("ACTIVE") && data.has("SIGNUP_INPROGRESS")) || (data.has("ACTIVE") && data.has("INACTIVE"))) {
        return false;
      } else if ((data.has("SIGNUP_INPROGRESS") && data.has("INACTIVE")) || (data.size == 1 && data.has("SIGNUP_INPROGRESS")) || (data.size == 1 && data.has("INACTIVE"))) {
        return true;
      } else {
        return false;
      }

    }
  }

  buildDeviceChartData(fanDetails, type, label, deviceEnrolledStatus?) {
    this.chartData[type] = [];
    this.legendData[type] = [];
    this.chartLabel[type] = label;
    let legendCounter = 0;
    this.handleFutureEnrollment(fanDetails);
    fanDetails = fanDetails.filter((o) => Object.keys(o).length);

    fanDetails.forEach((d, i) => {
      const chartConfig = CHART_CONFIG[d.status];
      const temp: DonutChartModel = {
        value: d.noOfDevices,
        color: chartConfig.color,
        legend: d.noOfDevices + " " + chartConfig.label,
      };
      if (d.noOfDevices) {
        this.chartData[type].push(temp);
      }
      // this.legendData[type][fanDetails.length / 2 > i ? 'left' : 'right'].push(temp);
    });

    let count = 0;
    let tempChartData = [];
    tempChartData = this.chartData[type].filter(function (x, i) {
      if (
        x.value > 0 &&
        (x.legend.indexOf("claimed (Apple)") > -1 ||
          x.legend.indexOf("claimed (Samsung)") > -1 ||
          x.legend.indexOf("claimed (Android™)") > -1 ||
          x.legend.indexOf("claimed (Android)") > -1)
      ) {
        count += x.value;
      }

      return (
        x.value > 0 &&
        x.legend.indexOf("claimed (Apple)") <= -1 &&
        x.legend.indexOf("claimed (Samsung)") <= -1 &&
        x.legend.indexOf("claimed (Android™)") <= -1 &&
        x.legend.indexOf("claimed (Android)") <= -1
      );
    });

    if (count > 0) {
      this.chartData[type] = tempChartData; //data except claimed
      const chartConfigClaim = CHART_CONFIG["CLAIM_SUCCESS"];
      const claimMerge = {
        value: count,
        color: chartConfigClaim.color,
        legend: count + " " + chartConfigClaim.label,
      };

      this.chartData[type].push(claimMerge);
    }

    let arr = [];
    let arr1 = this.chartData[type].filter(
      (x) => x.legend.indexOf("not claimed") > -1
    );
    if (arr1.length > 0) {
      arr.push(arr1.pop());
    }
    let arr2 = this.chartData[type].filter(
      (x) => x.legend.indexOf("unclaim pending") > -1
    );
    if (arr2.length > 0) {
      arr.push(arr2.pop());
    }
    let arr3 = this.chartData[type].filter(
      (x) =>
        x.legend.indexOf("claim pending") > -1 &&
        x.legend.indexOf("unclaim pending") < 0
    );
    if (arr3.length > 0) {
      arr.push(arr3.pop());
    }
    let arr4 = this.chartData[type].filter(
      (x) =>
        x.legend.indexOf("claimed") > -1 && x.legend.indexOf("not claimed") < 0
    );
    if (arr4.length > 0) {
      arr.push(arr4.pop());
    }

    this.chartData[type] = arr;
    this.legendData[type] = this.chartData[type];
    this.pageLoaderService.setPageLoaderStatus(true);

    // this.chartData[type].forEach((x, i) =>{
    //   // if legendcounter is even, show legend on the left else on the right
    //   this.legendData[type][legendCounter % 2 === 0 ? 'left' : 'right'].push(x);
    //   legendCounter++;

    // })
  }
  handleFutureEnrollment(fanDetails) {
    let futureEnrollmentCount = 0;
    let futureEnrollmentCountIndex;
    fanDetails = fanDetails.filter((o) => Object.keys(o).length);
    fanDetails.forEach((d, i) => {
      if (d.status === "FUTURE_ENROLLMENT") {
        futureEnrollmentCount = d.noOfDevices;
        futureEnrollmentCountIndex = i;
      }
    });
    fanDetails.forEach((d, i) => {
      if (
        (d.status === "NOT_ENROLLED" || d.status === "NOT_CLAIMED") &&
        futureEnrollmentCountIndex !== undefined
      ) {
        fanDetails.splice(futureEnrollmentCountIndex, 1);
        d.noOfDevices = d.noOfDevices + futureEnrollmentCount;
      }
    });
  }

  getAppleCertificateStatus() {
    this.manageDashboardService.getAppleSummary().subscribe(
      (respobj2) => {
        this.fanStatus.appleCertificate = respobj2.status;
        this.appleInstalled =
          this.dashboardData.appleCertificate[respobj2.status];
        const addpDashboardContainer =
          this.el.nativeElement.getElementsByClassName(
            "addp-dashboard-container"
          );
        if (
          this.fanStatus.noOfFans > 1 ||
          (this.fanStatus.noOfFans === 1 &&
            addpDashboardContainer[0].firstElementChild.firstElementChild
              .classList[1] !== "device-status-container")
        ) {
          if (this.FanLegendCount > 2) {
            addpDashboardContainer[0].classList.add("size-set");
          } else {
            addpDashboardContainer[0].classList.add("size-set-1");
          }
        } else if (this.fanStatus.noOfFans === 1) {
          if (
            this.fanStatus.initialSignupStatus === "Completed" &&
            (this.fanStatus.deviceEnrolledStatus === "Completed" ||
              this.fanStatus.deviceEnrolledStatus === "Future Enrollment")
          ) {
            addpDashboardContainer[0].classList.add("size-set-2");
          } else {
            addpDashboardContainer[0].classList.add("size-set-3");
          }
        }
      },
      (error) => this.handleError(error, "FETCH_APPLECERT_STATUS")
    );
  }

  checkAwaitingSetUp(fanDetails) {
    fanDetails = fanDetails.filter((o) => Object.keys(o).length);
    fanDetails.forEach((d, i) => {
      if (d.status === "READY_TO_SETUP") {
        this.readyToSetupCount = 0;
        //this.readyToSetup = true;
      }
    });
  }

  // Report pop up functionality
  initReportPopupModal() {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.showReportPopup = true;
  }

  closeReportPopup() {
    this.showReportPopup = false;
  }

  ngOnDestroy() {
    this.pageLoaderService.setPageLoaderStatus(true);
  }
}
